export class Login {
  static path = '/api/authentication/login';
}
